/**
 * ErrorBoundary 组件用于全局 React 错误捕获
 * tips：由于 react-router-dom 进行了所有路由的运行时错误捕获，故大部分错误将会被 router/error-page.js 捕获
 * @module ErrorBoundary
 * @see https://zh-hans.reactjs.org/docs/error-boundaries.html
 */

import { Component } from 'react';
import ErrorBlock from '@/components/error-block';

class ErrorBoundary extends Component {
  constructor (props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError () {
    return { hasError: true };
  }

  render () {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <ErrorBlock
          text='The theater has encountered some problems.'
          btnText='Click to refresh'
          onClick={ () => window.location.href = '/m' }
        />
      );
    }

    return children;
  }
}

export default ErrorBoundary;
